import { type SelectedProduct, useTradeSalesStore } from "@fero/stores";
import { useState } from "react";

export const useManageBrowseProducts = () => {
  const [isBrowseOpen, setIsBrowseOpen] = useState(false);
  const {
    addBrowsingProduct,
    removeBrowsingProduct,
    setBrowsingProducts,
    browsingProducts,
  } = useTradeSalesStore();

  const toggleBrowsingProduct = (
    product: SelectedProduct,
    selected: boolean,
  ) => {
    if (selected) {
      addBrowsingProduct(product);
    } else {
      removeBrowsingProduct(product);
    }
  };

  const clearBrowsingProducts = () => {
    setBrowsingProducts([]);
  };

  return {
    isBrowseOpen,
    openBrowse: (selectedProducts: SelectedProduct[]) => {
      setBrowsingProducts(selectedProducts);
      setIsBrowseOpen(true);
    },
    closeBrowse: () => setIsBrowseOpen(false),
    browsingProducts,
    toggleBrowsingProduct,
    clearBrowsingProducts,
  };
};
